export type RewardPlacement = 'continue-run' | 'double-page-reward';
export type StoreProductId = 'remove_ads' | `cosmetic_${string}` | `world_pack_${string}`;
export interface PlannedStoreProduct {
  id: StoreProductId;
  title: string;
  kind: 'story world' | 'cosmetic collection';
  description: string;
}

/** Content reserved for a future native store; no prices or checkout are active in the web build. */
export const PLANNED_STORE_PRODUCTS: PlannedStoreProduct[] = [
  { id: 'world_pack_moonlit_archive', title: 'The Moonlit Archive', kind: 'story world', description: 'A future illustrated world with new characters and a complete three chapter campaign.' },
  { id: 'cosmetic_starlight_wardrobe', title: 'The Starlight Wardrobe', kind: 'cosmetic collection', description: 'A future set of original outfits and page trails for the existing cast.' },
];

export type ProviderResult<T = void> =
  | { status: 'complete'; value?: T }
  | { status: 'unavailable' }
  | { status: 'cancelled' };

/** Platform seam for a future Capacitor/native store adapter. */
export interface MonetizationPort {
  readonly isReady: boolean;
  showRewarded(placement: RewardPlacement): Promise<ProviderResult>;
  purchase(productId: StoreProductId): Promise<ProviderResult>;
  restorePurchases(): Promise<ProviderResult<{ productIds: StoreProductId[] }>>;
  isAdsRemoved(): Promise<boolean>;
}

/** Safe default for browser builds: no SDK, tracking, payment, or ad request. */
export const unavailableMonetization: MonetizationPort = {
  isReady: false,
  async showRewarded() { return { status: 'unavailable' }; },
  async purchase() { return { status: 'unavailable' }; },
  async restorePurchases() { return { status: 'unavailable' }; },
  async isAdsRemoved() { return false; },
};
